export default function WhyProjectBased() {
  return (
    <section id="why" data-testid="section-why" className="bg-mist">
      <div className="mx-auto max-w-[1100px] px-6 py-24 md:px-10 md:py-36 lg:py-40">
        <p className="eyebrow">How I work</p>
        <h2 className="section-heading mt-4 max-w-[760px]">
          Why most of my engagements have an end date.
        </h2>

        <p
          data-testid="why-belief"
          className="mt-12 max-w-[680px]"
          style={{
            fontFamily: "Fraunces, Georgia, serif",
            fontOpticalSizing: "auto",
            fontVariationSettings: '"opsz" 144',
            fontWeight: 500,
            fontSize: "clamp(1.5rem, 2.4vw, 1.75rem)",
            lineHeight: 1.25,
            letterSpacing: "-0.015em",
            color: "var(--color-deep-lake)",
          }}
        >
          {"I believe that \u201Cthinking like an owner\u201D is teachable."}
        </p>

        <div className="mt-8 max-w-[680px] space-y-6">
          <p
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "18px",
              lineHeight: 1.7,
              color: "rgba(26,58,79,0.88)",
            }}
          >
            {"That\u2019s the belief behind how I work. Most consulting relationships are built to last. Mine aren\u2019t. I take on projects with a clear scope and a defined end. The frameworks, the AI implementations, the cross-functional habits. They can all be taught."}
          </p>
          <p
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "18px",
              lineHeight: 1.7,
              color: "rgba(26,58,79,0.88)",
            }}
          >
            {"It\u2019s also how you get the sharpest version of the work. Full attention while we\u2019re in it. A clean exit when we\u2019re done."}
          </p>
        </div>

        <p
          data-testid="why-pull-quote"
          className="mt-16 md:mt-20 flex items-baseline gap-3 max-w-[680px]"
          style={{
            fontFamily: "Fraunces, Georgia, serif",
            fontOpticalSizing: "auto",
            fontVariationSettings: '"opsz" 144',
            fontWeight: 500,
            fontSize: "clamp(1.5rem, 2.6vw, 1.875rem)",
            lineHeight: 1.25,
            letterSpacing: "-0.015em",
            color: "var(--color-deep-lake)",
          }}
        >
          <span>{"Your team owns what comes next."}</span>
          <span
            aria-hidden="true"
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              borderRadius: "9999px",
              backgroundColor: "var(--color-terracotta)",
              flexShrink: 0,
              transform: "translateY(-2px)",
            }}
          />
        </p>
      </div>
    </section>
  );
}
